import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchService } from '@ukam/core/services/search.service';
import { SearchResult } from '@ukam/core/searchs/search-result';
import { FilterSearchResult } from '../models/filter-search-result';
import { API_BASE_URL } from '@ukam/core/tokens/api-base-url.token';

@Injectable({
  providedIn: 'root',
})
export class FilterSearchService extends SearchService<FilterSearchResult> {


  constructor() {
    super(
      {
        url: `${inject(API_BASE_URL)}/filters/search`,
        limit: 100
      },
    );
  }

  override search(params?: any): Observable<SearchResult<FilterSearchResult>> {
    this.params = { ...this.params, searchText: this.searchText() };
    return this._search();
  }

}
